export default {
  apiServExt: process.env.VUE_APP_BASE_URL,
  apiCore: process.env.VUE_APP_BASE_CORE,
  apiUrl: process.env.VUE_APP_BASE_EXT,
  apiPhp: process.env.VUE_APP_BASE_SERVICE_EXT,
  apiLaravel: process.env.VUE_APP_LARAVEL_URL,
}
